import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { hotjar } from 'react-hotjar';
import { store } from './app/store';
import { AuthProvider } from './hooks/useAuth';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import Header from './common/Header';

console.log('process.env.REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL)
console.log('process.env.REACT_APP_GTM_AUTH', process.env.REACT_APP_GTM_AUTH)
console.log('process.env.REACT_APP_GTM_PREVIEW', process.env.REACT_APP_GTM_PREVIEW)
console.log('process.env.REACT_APP_HOTJAR_SITE_ID', process.env.REACT_APP_HOTJAR_SITE_ID)
console.log('process.env.REACT_APP_HOTJAR_SNIPPET_VERSION', process.env.REACT_APP_HOTJAR_SNIPPET_VERSION)
console.log('process.env.REACT_APP_HEAP_ID', process.env.REACT_APP_HEAP_ID)

TagManager.initialize({
  gtmId: 'GTM-TNGQNDT',
  auth: process.env.REACT_APP_GTM_AUTH,
  preview: process.env.REACT_APP_GTM_PREVIEW,
})

hotjar.initialize(
  process.env.REACT_APP_HOTJAR_SITE_ID,
  process.env.REACT_APP_HOTJAR_SNIPPET_VERSION
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Provider store={store}>
          <Header />
          <App />
        </Provider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
